export enum ThemeType {
  MINNA = 'Minna',
  WAFFLE = 'Waffle',
  SPANISH_OMELETTE = 'SpanishOmelette',
  OpBank = 'OpBank',
  Anyfin = 'Anyfin',
  LittleBirdie = 'LittleBirdie',
  Zlantar = 'Zlantar',
}
